module.exports = __webpack_public_path__ + "static/media/electronics.967212f3.jpg";